"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("react"),r=require("prop-types"),t=require("@vds-core/modals"),o=require("@vds/buttons");function u(e){return e&&e.__esModule?e:{default:e}}var a=u(e);const s={surface:u(r).default.oneOf(["light","dark"])},d=function(e){return a.default.createElement(t.ModalFooter,Object.assign({},e,{ButtonGroup:o.ButtonGroup}),e.children)};d.propTypes=s,d.defaultProps={surface:"light"},d.displayName="ModalFooter",exports.default=d;



//////////////////
// WEBPACK FOOTER
// ./~/@vds/modals/cjs/components/ModalFooter.js
// module id = 1485
// module chunks = 0